
import { 
  HelpCircle, BookOpen, Shield, File, Bell,
  Share2, Cloud, UserPlus, Map, Smartphone,
  Zap, Settings, AlertTriangle, Calendar, Globe, Table, CreditCard
} from 'lucide-react';
import { FAQCategory } from '@/components/faq/types';

export const faqCategories: FAQCategory[] = [
  {
    id: 'getting-started',
    title: 'Getting Started',
    description: 'Everything you need to know to create your first pet digital identity',
    icon: BookOpen,
    count: 8,
    color: 'text-emerald-600'
  },
  {
    id: 'security-privacy',
    title: 'Security & Privacy',
    description: 'How we protect your pet\'s sensitive information and digital identity',
    icon: Shield,
    count: 6,
    color: 'text-blue-600'
  },
  {
    id: 'documents',
    title: 'Document Management',
    description: 'Uploading, organizing, and sharing your pet documents and records',
    icon: File,
    count: 8,
    color: 'text-purple-600'
  },
  {
    id: 'reminders',
    title: 'Reminders & Scheduling',
    description: 'Setting up alerts for medications, appointments and health care',
    icon: Bell,
    count: 6,
    color: 'text-orange-600'
  },
  {
    id: 'platform',
    title: 'Platform & Features',
    description: 'Understanding My Pet ID features, mobile apps, and accessibility',
    icon: Settings,
    count: 7,
    color: 'text-indigo-600'
  },
  {
    id: 'emergency-support',
    title: 'Emergency & Support',
    description: 'Accessing records during emergencies and getting help when needed',
    icon: AlertTriangle,
    count: 5,
    color: 'text-red-600'
  }
];
